import { capitalize } from './DataFormatterUtils';
import { nullSafeGet } from './DataAccessUtils';

export const mappingTemplateTypesForDisplay = (record) =>
	record.type.toLowerCase() === 'string' ? 'text' : record.type;

export const mappingApprovalTypesForLinks = (record) =>
	record.approvalHierarchyType === 'proposal' ? 'quoteApprovalConfig' : 'invoiceApprovalConfig';

const normalizeArray = (arr) => (arr && arr.length > 0 ? arr.slice().sort() : undefined);

export const mappingApprovalRuleComparisonData = (record) => ({
	isCapex: record.isCapex,
	isPM: record.isPM,
	woPriorityIds: normalizeArray(record.woPriorityIds),
	problemTypeIds: normalizeArray(record.problemTypeIds),
	stockLocationIds: normalizeArray(record.stockLocationIds),
	fieldTechEmails: normalizeArray(record.fieldTechEmails),
});

export const mappingApprovalRulesURLForTypes = (record) =>
	nullSafeGet('params.type', record) === 'quote'
		? 'proposal'
		: nullSafeGet('params.type', record) === 'invoice'
		? 'invoice'
		: nullSafeGet('params.type', record) === 'purchaseRequest'
		? 'purchaseRequest'
		: 'workOrder';

export const mappingApprovalRulesURLForTargetCollection = (record) =>
	nullSafeGet('params.type', record) === 'quote'
		? 'Quote'
		: nullSafeGet('params.type', record) === 'invoice'
		? 'Invoice'
		: nullSafeGet('params.type', record) === 'purchaseRequest'
		? 'PurchaseRequest'
		: 'WorkOrder';

export const mappingURLParamsToAddApprovalButton = (s) =>
	s === 'workOrder' ? 'work order' : s === 'purchaseRequest' ? 'purchase request' : s;
